console.log("Product options loaded");

const options = document.querySelectorAll("variant-radios input");

options.forEach((element) => {
    element.addEventListener("click", (event) => {
        const target = event.target;
        const level = parseInt(target.dataset.productOptionLevel, 10);
        const nextOptions = target.dataset.productOptionsLevelNextValues;

        disableLowerOptions(level);
        enableNextOptions(nextOptions, level);
    });
});

function checkProductOption() {}

function disableLowerOptions(level) {
    for (let index = level; index <= 3; index++) {
        const lowerLevel = index + 1;
        const lowerLevelInputs = document.querySelectorAll(`input[data-product-option-level="${lowerLevel}"]`);
        lowerLevelInputs.forEach(element => {
            element.disabled = true;
            element.checked = false;
        });
    }
}

function enableNextOptions(options, level) {
    const optionsArray = options.split(", ");

    if (level == 3) { return }

    if (level == 2) {
        const validCombinations = document.querySelector('variant-radios').dataset.validCombinations;
        const combinationsArray = validCombinations.split(',');
        const selectedLevel1 = document.querySelector('input[data-product-option-level="1"]:checked').value;
        const selectedLevel2 = document.querySelector('input[data-product-option-level="2"]:checked').value;

        optionsArray.forEach(level3Value => {
            const combination = `${selectedLevel1} / ${selectedLevel2} / ${level3Value}`;
            const element = document.querySelector(`input[data-product-option-level="3"][value="${level3Value}"]`);
            const isValid = combinationsArray.includes(combination);
            if ( isValid ) {
                element.disabled = false;
            } else {
                element.disabled = true;
                element.checked = false;
            }
        });

        return
    }

    for (let index = 0; index < optionsArray.length; index++) {
        const option = optionsArray[index];
        const targetLevel = level + 1;
        const target = document.querySelector(
            `input[data-product-option-level="${targetLevel}"][value="${option}"]`
        );
        target.disabled = false;
    }
}
